export default __webpack_public_path__ + "static/media/manutencao-computadores.4fd018d4.png";